import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="events-table-search"
export default class extends Controller {
  static targets = ["input", "content"]
  static values = {
    debounce: { type: Number, default: 300 }
  }

  connect() {
    this.timeout = null
  }
  
  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  search(event) {
    // Debounce the search
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    
    this.timeout = setTimeout(() => {
      this.filterLocal()
    }, this.debounceValue)
  }

  // Both the desktop table body and the mobile card list are `content` targets;
  // each holds [data-search-item] elements (table rows / accordion cards). Only
  // one list is visible at a time (CSS), so filtering both is harmless and keeps
  // search working on whichever layout is shown.
  get items() {
    return this.contentTargets.flatMap((c) =>
      Array.from(c.querySelectorAll("[data-search-item]"))
    )
  }

  filterLocal() {
    const searchTerm = this.inputTarget.value.toLowerCase().trim()

    // If search term is empty, show all rows
    if (searchTerm === "") {
      this.showAllRows()
      return
    }

    // Loop through each item (table row or card) and match on its text.
    this.items.forEach((item) => {
      const isVisible = item.textContent.toLowerCase().includes(searchTerm)
      item.style.display = isVisible ? "" : "none"
    })
  }

  handleKeydown(event) {
    // Clear the search input when Escape key is pressed
    if (event.key === "Escape") {
      this.inputTarget.value = ""
      this.showAllRows()
      
      // Clear any pending search
      if (this.timeout) {
        clearTimeout(this.timeout)
      }
    }
  }

  showAllRows() {
    // Restore every item (table rows + cards) to its default display.
    this.items.forEach((item) => {
      item.style.display = ""
    })
  }
}
